
$(document).ready( function() {
	const $heroVideo = $('#hero-video');
	if ( $heroVideo.length > 0) {
		const mediaVideo = $heroVideo.get(0);
		const $btnMute = $('.js-video-controls .mute-control');
		const $btnPause = $('.js-video-controls .pause-control');
		const hero_video = $('.hero-video-wrapper');
		const has_slideshow = $heroVideo.attr('slideshow');

		if ( document.getElementById("hero-embed").classList.contains("mobile-video") ) {
			$btnPause.find('.icon').removeClass('stop');
		}

		function toggleSlideshow() {
			mediaVideo.pause();
			mediaVideo.muted=true;
			hero_video.addClass('hide-video');
		}

		if (has_slideshow == '1') {
			$heroVideo.on('ended', toggleSlideshow);
			$heroVideo.on('click', toggleSlideshow);

			const hero_replay_btn = $('.hero-video-play');
			if (hero_replay_btn) {
				hero_replay_btn.on('click', function(){
					hero_video.removeClass('hide-video');
					mediaVideo.play();
				});
			}
		}

		$btnPause.on('click', ev => {
			if (mediaVideo.paused) {
				mediaVideo.play();
				$btnPause.find('.icon').removeClass('stop');
			} else {
				mediaVideo.pause();
				$btnPause.find('.icon').addClass('stop');
			}
		});
		$btnMute.on('click', ev => {
			if (mediaVideo.muted) {
				$btnMute.find('.icon').addClass('stop');
			} else {
				$btnMute.find('.icon').removeClass('stop');
			}
			mediaVideo.muted = !mediaVideo.muted;
		});
	}
});

if ( document.body.classList.contains( 'page-template-gallery' ) ) {
	let categories = document.querySelectorAll( '.media-category-wrapper' );
	let categoryTabs = document.querySelectorAll( '.js-media-category' );
	for ( let i=0; i<categoryTabs.length; i++ ) {
		categoryTabs[i].addEventListener( 'click', function() {
			let target = this.getAttribute('data-target');
			for (let j=0; j<categories.length; j++) {
				categories[j].classList.add('d-none');
			}
			for (let j=0; j<categoryTabs.length; j++) {
				categoryTabs[j].classList.remove('active-tab');
			}
			categoryTabs[i].classList.add('active-tab');
			let m = document.querySelectorAll('.media-category-wrapper.' + target);
			for (let j=0; j<m.length; j++) {
				m[j].classList.remove('d-none');
			}
		})
	}
}
